/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Schedule } from './Schedule';
import {
    ScheduleFromJSON,
    ScheduleFromJSONTyped,
    ScheduleToJSON,
} from './Schedule';

/**
 * 
 * @export
 * @interface SchedulesResponse
 */
export interface SchedulesResponse {
    /**
     * 
     * @type {Array<Schedule>}
     * @memberof SchedulesResponse
     */
    records?: Array<Schedule>;
}

/**
 * Check if a given object implements the SchedulesResponse interface.
 */
export function instanceOfSchedulesResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SchedulesResponseFromJSON(json: any): SchedulesResponse {
    return SchedulesResponseFromJSONTyped(json, false);
}

export function SchedulesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ScheduleFromJSON)),
    };
}

export function SchedulesResponseToJSON(value?: SchedulesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ScheduleToJSON)),
    };
}

